import './GenericToolbarItem.207d18a735f843cb411afff5c97d569e.css';
export default {"item":"_item_7wgli_1","active":"_active_7wgli_1"};